import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
import { ConstellationBackgroundLayerItem } from "@/components/constellation-background/ConstellationBackgroundLayerItem";
const MAX_ITEMS = 18;
const MANY_ITEMS_CUTOFF = 5;
export function ConstellationBackgroundLayer(t0) {
  const $ = _c(13);
  const {
    background
  } = t0;
  let t1;
  let t2;
  if ($[0] !== background) {
    const items = background.items.slice(0, MAX_ITEMS);
    const hasManyItems = items.length >= MANY_ITEMS_CUTOFF;
    let t3;
    if ($[3] !== hasManyItems) {
      t3 = hasManyItems ? {
        ellipseRotation: -15
      } : {
        blur: false,
        scaleOffset: 0.3,
        ellipseRotation: 0
      };
      $[3] = hasManyItems;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const additionalItemProps = t3;
    const t4 = hasManyItems && "rotate-[15deg]";
    if ($[5] !== t4) {
      t1 = classNames("pointer-events-none fixed inset-0 size-full", t4);
      $[5] = t4;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t5;
    if ($[7] !== additionalItemProps || $[8] !== background) {
      t5 = (item, i) => <ConstellationBackgroundLayerItem background={background} index={i} item={item} key={item.id} {...additionalItemProps} />;
      $[7] = additionalItemProps;
      $[8] = background;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t2 = items.map(t5);
    $[0] = background;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}